<template>
  <section class="section-soundbar">
    <h2 class="title-soundbar">Compre junto uma Soundbar</h2>

    <div class="resources">
      <div class="image-soundbar">
        <img :src="this.soundbar.image" alt="" />
      </div>

      <div class="resources-soundbar">
        <div v-for="(resource, index) in this.soundbar.resource" :key="index">
          <img :src="resource.icon" alt="" />
          <span>{{resource.title}}</span>
        </div>
      </div>
    </div>

    <section class="soundbar-section-footer">
      <button id="btn_voltar_lista_soundbar" class="link" v-on:click="backToTop">Voltar</button>
      <button id="btn_compre_agora_soundbar" class="button primary" v-on:click="handleClickBuyNow">Compre junto</button>
    </section>
  </section>
</template>

<script>

export default {
  name: "Soundbar",
  components: {},
  props: ["sendAnalytics", "soundbar", "selectedTv"],
  data() {},
  computed: {},
  mounted() {
  },
  methods: {
    backToTop() {
      this.$emit("backToTop");
    },
    handleClickBuyNow(){
      window.open(this.selectedTv.shopSoundbarUrlTagged);
      
      // Analytics Samsung
      window.click_s_evar_event('o', '26', 'compre-junto-soundbar', 'click', 'compre_junto'+ '-'+ this.soundbar.soundbarModel);

      // Analytics Môre
      window.dataLayer.push({
            event: "gtm.conversion.soundbar",
            target: "gtm-more",
            action: `compre_junto`,
            modelo_TV: this.selectedTv.displayName,
            polegadas: this.selectedTv.size,
            modelo_Soundbar: this.soundbar.soundbarModel
            // label: "target-properties",
            // value: 5000,
            // noninteraction: "interaction-type",
          });

      // console.log("teste")
      // console.log("soundbar", this.soundbar.tvModel)
      // console.log("Tamanho TV:", this.selectedTv.size )
      // console.log("Modelo TV:", this.selectedTv.displayName)
      // console.log("TV Com Soundbar:", this.selectedTv.shopSoundbarUrlTagged)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/main.scss";

.section-soundbar {
  width: 100%;
  padding: 54px 14px;
  text-align: center;

  .title-soundbar {
    font-family: $font-family-title;
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 40px;
    color: rgba(0, 0, 0, 0.8);
  }

  .resources {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1152px;
    margin: 0 auto;
    
    .image-soundbar {
      img {
        max-width: 100%;
      }
    }

    .resources-soundbar {
      margin: auto 0;
      display: flex;
      align-items: flex-start;
      padding-left: 40px;

      div:not(:last-child) {
        border-right: 2px solid #6E6A69;
      }

      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;

        width: 190px;
        height: 105px;

        padding: 0 10px 0 10px;

        img{
          width: 120px;
          height: 64px;
        }

        span {
          font-size: 12px;
          font-weight: bold;
          line-height: 16px;
        }
      }
    }
  }

  .soundbar-section-footer{
    display: flex; 
    justify-content: center; 
    gap: 2rem;

    padding-top: 3rem;
  }
}

@media (max-width: 980px) {
  .section-soundbar {
    padding: 32px 14px;

    .title-soundbar {
      font-family: $font-family-title;
      font-size: 1.25rem;
      line-height: 1.75rem;
      margin-bottom: 16px;
      text-align: center;
    }

    .resources {
      display: flex;
      flex-direction: column;
      height: 257px;

      position: relative;

      .resources-soundbar {
        margin-top: 8px;
        display: flex;
        padding: 0;
        
        width: 100%;
        height: 107px;
        position: absolute;
        overflow-x: auto;
        overflow-y: hidden;
        top: 150px;
        left: 0;

        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
      }

      .resources-soundbar::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
      }
    }
  }
}
</style>